document.addEventListener('click', function (e) {
  var item = e.target.closest('[data-target]');
  if (!item) return;
  var mediaWrapper = item.closest('.product__media-wrapper');
  if (!mediaWrapper) return;

  // Manually manage the highlighted/selected thumbnail ourselves. The
  // native code (media-gallery.js / SliderComponent) decides which
  // thumbnail is "current" based on horizontal scroll-position math,
  // which breaks once the silicone mobile grid CSS turns the thumbnail
  // strip into a multi-row grid instead of a single horizontal line.
  // That mismatch is what caused the visible highlight to drift onto
  // the wrong thumbnail. We bypass that entirely here and just mark
  // whatever was actually clicked as current.
  var thumbSlider = item.closest('.thumbnail-slider');
  if (thumbSlider && thumbSlider.classList.contains('silicone-mobile-thumb-grid')) {
    thumbSlider.querySelectorAll('[data-target] button').forEach(function (btn) {
      btn.removeAttribute('aria-current');
    });
    var clickedButton = item.querySelector('button');
    if (clickedButton) clickedButton.setAttribute('aria-current', 'true');
  }

  var mapEl = mediaWrapper.querySelector('script[id^="MediaColorMap-"]');
  if (!mapEl) return;
  var container = mediaWrapper.parentElement;
  if (!container) return;
  var select = container.querySelector('select[name="options[Color]"]');
  if (!select) return;
  var targetAttr = item.getAttribute('data-target');
  if (!targetAttr) return;
  var mediaId = targetAttr.split('-').pop();

  // Preload the full-screen zoom image for this photo now, in the
  // background, so it's already downloaded (or nearly there) by the
  // time the person actually taps zoom, instead of only starting the
  // fetch at that moment.
  var modalImg = document.querySelector('.product-media-modal__content [data-media-id="' + mediaId + '"] img');
  if (modalImg) {
    var preloadUrl = modalImg.currentSrc || modalImg.src;
    if (preloadUrl) {
      var preloader = new Image();
      preloader.src = preloadUrl;
    }
  }

  var entries;
  try {
    entries = JSON.parse(mapEl.textContent);
  } catch (err) {
    return;
  }
  var entry = null;
  for (var i = 0; i < entries.length; i++) {
    if (String(entries[i].media) === String(mediaId)) {
      entry = entries[i];
      break;
    }
  }
  if (!entry || !entry.color) return;
  if (select.value === entry.color) return;
  select.value = entry.color;
  select.dispatchEvent(new Event('change', { bubbles: true }));
}, true);

(function () {
  function trimBadge(el) {
    if (el.dataset.trimmed) return;
    el.textContent = el.textContent.replace(/-225$/, '');
    el.dataset.trimmed = '1';
  }

  function trimAll() {
    document
      .querySelectorAll('.product__thumbnail-sku-overlay, .product__media-sku-overlay')
      .forEach(trimBadge);
  }

  trimAll();

  var observer = new MutationObserver(function () {
    trimAll();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  var STYLE_ID = 'jig-color-grid-styles';

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.jig-native-thumbnails-hidden{display:none !important;}' +
      '.jig-mini-slider{display:flex;gap:1rem;margin-top:1.5rem;justify-content:center;}' +
      '.jig-mini-slider__item{flex:0 0 auto;width:8rem;padding:0;border:0.15rem solid transparent;' +
      'border-radius:0.5rem;cursor:pointer;background:none;}' +
      '.jig-mini-slider__item img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:0.4rem;display:block;}' +
      '.jig-mini-slider__item[aria-current="true"]{border-color:rgb(var(--color-foreground));}' +
      '.jig-color-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:1rem;margin-top:1.5rem;width:100%;}' +
      '.jig-color-grid__item{display:flex;flex-direction:column;align-items:center;gap:0.5rem;' +
      'background:none;border:0;border-radius:0;width:100%;' +
      'padding:0.3rem;cursor:pointer;font-family:inherit;color:inherit;}' +
      '.jig-color-grid__item img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:0.5rem;display:block;}' +
      '.jig-color-grid__item span{font-size:1.92rem;text-align:center;line-height:1.2;}' +
      '.jig-color-grid__item[aria-current="true"] img{outline:0.2rem solid rgb(var(--color-foreground));outline-offset:0.2rem;}' +
      '@media screen and (max-width: 749px) {' +
      '  .silicone-mobile-thumb-grid .thumbnail-list {' +
      '    display: grid !important;' +
      '    grid-template-columns: repeat(3, 1fr) !important;' +
      '    overflow: visible !important;' +
      '    gap: 0.8rem !important;' +
      '  }' +
      '  .silicone-mobile-thumb-grid .thumbnail-list__item {' +
      '    width: 100% !important;' +
      '    max-width: none !important;' +
      '  }' +
      '  .silicone-mobile-thumb-grid .thumbnail-list .thumbnail {' +
      '    width: 100% !important;' +
      '    height: auto !important;' +
      '    aspect-ratio: 1 / 1 !important;' +
      '    border-radius: 0.6rem !important;' +
      '    display: block !important;' +
      '    overflow: hidden !important;' +
      '  }' +
      '  .silicone-mobile-thumb-grid .thumbnail-list .thumbnail img {' +
      '    width: 100% !important;' +
      '    height: 100% !important;' +
      '    max-width: none !important;' +
      '    object-fit: cover !important;' +
      '    border-radius: 0.6rem !important;' +
      '  }' +
      '  .silicone-mobile-thumb-grid .slider-buttons { display: none !important; }' +
      '  .silicone-mobile-grid-active > .slider-buttons { display: none !important; }' +
      '  .silicone-mobile-grid-active [id^="Slider-Gallery-"] {' +
      '    overflow: hidden !important;' +
      '    scroll-snap-type: none !important;' +
      '    touch-action: pan-y pinch-zoom !important;' +
      '    display: block !important;' +
      '  }' +
      '  .silicone-mobile-grid-active [id^="Slider-Gallery-"] > .product__media-item {' +
      '    display: none !important;' +
      '  }' +
      '  .silicone-mobile-grid-active [id^="Slider-Gallery-"] > .product__media-item.is-active {' +
      '    display: block !important;' +
      '    width: 100% !important;' +
      '  }' +
      '}' +
      '.product-media-modal__toggle {' +
      '  width: 4.6rem !important;' +
      '  height: 4.6rem !important;' +
      '  background-color: #000 !important;' +
      '  color: #fff !important;' +
      '  border-radius: 50% !important;' +
      '  display: flex !important;' +
      '  align-items: center !important;' +
      '  justify-content: center !important;' +
      '}' +
      '.product-media-modal__toggle svg {' +
      '  width: 2rem !important;' +
      '  height: 2rem !important;' +
      '}' +
      '.product__media-icon {' +
      '  top: 0.8rem !important;' +
      '  bottom: auto !important;' +
      '  left: auto !important;' +
      '  right: 2rem !important;' +
      '  width: 4.6rem !important;' +
      '  height: 4.6rem !important;' +
      '  background-color: #000 !important;' +
      '  color: #fff !important;' +
      '  border-radius: 50% !important;' +
      '  display: flex !important;' +
      '  align-items: center !important;' +
      '  justify-content: center !important;' +
      '}' +
      '.product__media-icon svg {' +
      '  width: 2rem !important;' +
      '  height: 2rem !important;' +
      '}' +
      '.product__media-icon--none {' +
      '  display: none !important;' +
      '}';
    document.head.appendChild(style);
  }

  function isVisible(el) {
    var rect = el.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;
    var style = window.getComputedStyle(el);
    if (style.visibility === 'hidden' || style.display === 'none') return false;
    return true;
  }

  function findHeroImage(mediaWrapper) {
    var imgs = mediaWrapper.querySelectorAll('img');
    var best = null;
    var bestWidth = 0;
    imgs.forEach(function (im) {
      if (!isVisible(im)) return;
      var w = im.getBoundingClientRect().width;
      if (w > bestWidth) {
        bestWidth = w;
        best = im;
      }
    });
    return best;
  }

  function setHeroSrc(hero, url) {
    if (!hero) return;
    hero.removeAttribute('srcset');
    hero.removeAttribute('sizes');
    hero.src = url;
  }

  function applySiliconeMobileGrid(variantSelects) {
    var countSelect = variantSelects.querySelector('select[name="options[Count]"]');
    var sizeSelect = variantSelects.querySelector('select[name="options[Size]"]');
    if (!countSelect || sizeSelect) return;

    var mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!mediaWrapper) return;
    var thumbSlider = mediaWrapper.querySelector('.thumbnail-slider');
    if (!thumbSlider) return;
    thumbSlider.classList.add('silicone-mobile-thumb-grid');

    // Disable swipe navigation on the main photo — the grid is now the
    // only way to browse colors on mobile for these products.
    var mainViewer = mediaWrapper.querySelector('slider-component.slider-mobile-gutter');
    if (mainViewer) {
      mainViewer.classList.add('silicone-mobile-grid-active');
    }
  }

  function buildGrid(variantSelects) {
    var colorSelect = variantSelects.querySelector('select[name="options[Color]"]');
    if (!colorSelect) return;

    // Only run on jig-style products (they have a Size option).
    // Silicone products have a Count option instead and must be left untouched.
    var sizeSelect = variantSelects.querySelector('select[name="options[Size]"]');
    var countSelect = variantSelects.querySelector('select[name="options[Count]"]');
    if (!sizeSelect || countSelect) return;

    var scriptTag = variantSelects.querySelector('script[type="application/json"]');
    if (!scriptTag) return;

    var variants;
    try {
      variants = JSON.parse(scriptTag.textContent);
    } catch (err) {
      return;
    }

    var seen = {};
    var colorEntries = [];
    variants.forEach(function (v) {
      var color = v.option1;
      if (!color || seen[color]) return;
      seen[color] = true;
      var img = v.featured_image && v.featured_image.src ? v.featured_image.src : null;
      colorEntries.push({ color: color, image: img });
    });

    if (colorEntries.length < 2) return;

    var mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!mediaWrapper) return;
    if (mediaWrapper.querySelector('.jig-color-grid')) return;

    var nativeThumbnails = mediaWrapper.querySelector('.thumbnail-slider');
    if (nativeThumbnails) {
      nativeThumbnails.classList.add('jig-native-thumbnails-hidden');
    }

    var allMediaEl = document.getElementById('AllProductMediaSrc');
    var allMedia = [];
    if (allMediaEl) {
      try {
        allMedia = JSON.parse(allMediaEl.textContent);
      } catch (err) {
        allMedia = [];
      }
    }

    var IMAGES_PER_COLOR = 3;

    function imagesForColorIndex(idx) {
      var start = idx * IMAGES_PER_COLOR;
      return allMedia.slice(start, start + IMAGES_PER_COLOR);
    }

    var miniSlider = null;
    if (allMedia.length >= colorEntries.length * IMAGES_PER_COLOR) {
      miniSlider = document.createElement('div');
      miniSlider.className = 'jig-mini-slider';
      mediaWrapper.appendChild(miniSlider);
    }

    function renderMiniSlider(colorIndex) {
      if (!miniSlider) return;
      miniSlider.innerHTML = '';
      var urls = imagesForColorIndex(colorIndex);
      urls.forEach(function (url, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'jig-mini-slider__item';
        btn.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        var img = document.createElement('img');
        img.src = url;
        img.alt = '';
        img.loading = 'lazy';
        btn.appendChild(img);
        btn.addEventListener('click', function () {
          var hero = findHeroImage(mediaWrapper);
          setHeroSrc(hero, url);
          miniSlider.querySelectorAll('.jig-mini-slider__item').forEach(function (b) {
            b.setAttribute('aria-current', 'false');
          });
          btn.setAttribute('aria-current', 'true');
        });
        miniSlider.appendChild(btn);
      });
      if (urls.length) {
        var hero = findHeroImage(mediaWrapper);
        setHeroSrc(hero, urls[0]);
      }
    }

    var grid = document.createElement('div');
    grid.className = 'jig-color-grid';

    function currentColorIndex() {
      var currentColor = colorSelect.value;
      for (var i = 0; i < colorEntries.length; i++) {
        if (colorEntries[i].color === currentColor) return i;
      }
      return 0;
    }

    function markCurrent() {
      var currentColor = colorSelect.value;
      grid.querySelectorAll('.jig-color-grid__item').forEach(function (cell) {
        cell.setAttribute('aria-current', cell.getAttribute('data-color') === currentColor ? 'true' : 'false');
      });
      renderMiniSlider(currentColorIndex());
    }

    colorEntries.forEach(function (entry) {
      var cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'jig-color-grid__item';
      cell.setAttribute('data-color', entry.color);

      var imgEl = document.createElement('img');
      imgEl.src = entry.image || '';
      imgEl.alt = entry.color;
      imgEl.loading = 'lazy';

      var label = document.createElement('span');
      label.textContent = entry.color;

      cell.appendChild(imgEl);
      cell.appendChild(label);

      cell.addEventListener('click', function () {
        if (colorSelect.value !== entry.color) {
          colorSelect.value = entry.color;
          colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        markCurrent();
      });

      grid.appendChild(cell);
    });

    mediaWrapper.appendChild(grid);
    markCurrent();

    colorSelect.addEventListener('change', markCurrent);

    // Lock the hero image so it can only change via the mini-slider
    // thumbnails or color-grid clicks above/below it, never by swiping
    // the hero photo itself left/right on mobile. Reuses the same lock
    // CSS already defined for the silicone mobile grid (hides sibling
    // media items, disables horizontal touch-action, hides slider
    // arrows) — the rule is generic and not silicone-specific.
    var mainViewer = mediaWrapper.querySelector('slider-component.slider-mobile-gutter');
    if (mainViewer) {
      mainViewer.classList.add('silicone-mobile-grid-active');
    }

    var productEl = mediaWrapper.closest('.product');
    if (productEl) {
      var mobileQuery = window.matchMedia('(max-width: 749px)');

      function applyMobileLayout(isMobile) {
        if (isMobile) {
          if (grid.parentElement !== productEl) {
            productEl.appendChild(grid);
          }
        } else {
          if (grid.parentElement !== mediaWrapper) {
            mediaWrapper.appendChild(grid);
          }
        }
      }

      applyMobileLayout(mobileQuery.matches);
      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', function (e) {
          applyMobileLayout(e.matches);
        });
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(function (e) {
          applyMobileLayout(e.matches);
        });
      }
    }
  }

  function init() {
    injectStyles();
    document.querySelectorAll('variant-selects').forEach(function (vs) {
      if (vs.dataset.jigGridInit) return;
      vs.dataset.jigGridInit = '1';
      buildGrid(vs);
      applySiliconeMobileGrid(vs);
      preloadAllZoomImages(vs);
    });
  }

  function preloadAllZoomImages(variantSelects) {
    var countSelect = variantSelects.querySelector('select[name="options[Count]"]');
    var sizeSelect = variantSelects.querySelector('select[name="options[Size]"]');
    if (!countSelect || sizeSelect) return;

    var modalContent = document.querySelector('.product-media-modal__content');
    if (!modalContent) return;
    var imgs = modalContent.querySelectorAll('img[srcset], img[src]');
    var urls = [];
    imgs.forEach(function (im) {
      var url = im.currentSrc || im.src;
      if (url) urls.push(url);
    });

    // Load them one at a time, a moment apart, well after the page has
    // had a chance to render, so this background work never competes
    // with or slows down the initial page load itself.
    function loadNext(index) {
      if (index >= urls.length) return;
      var preloader = new Image();
      preloader.onload = preloader.onerror = function () {
        setTimeout(function () {
          loadNext(index + 1);
        }, 60);
      };
      preloader.src = urls[index];
    }

    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () {
        loadNext(0);
      });
    } else {
      setTimeout(function () {
        loadNext(0);
      }, 1500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/**
 * Fix: mobile "zoom" button stops working on silicone products after
 * tapping a different color thumbnail.
 *
 * Root cause (best diagnosis without a confirmed console error): the
 * modal-opener custom element only wires up its click listener once,
 * to whichever <button> element existed inside it at the moment the
 * page first loaded. If anything downstream (variant/section re-render
 * triggered by the thumbnail-to-color-select sync above) replaces that
 * button element while leaving the modal-opener wrapper itself in place,
 * the original listener is left attached to a now-detached node and the
 * new button never gets one of its own.
 *
 * Fix: handle the zoom tap via event delegation instead of relying on a
 * listener bound to a specific node. This looks up the current button
 * and its modal fresh at the moment of the tap, so it keeps working no
 * matter what has been swapped out underneath it. It only takes over if
 * the modal isn't already open, so it won't double-fire on top of a
 * working native handler.
 */
document.addEventListener(
  'click',
  function (e) {
    var toggle = e.target.closest('.product__media-toggle');
    if (!toggle) return;
    var opener = toggle.closest('modal-opener');
    if (!opener) return;
    var modalSelector = opener.getAttribute('data-modal');
    if (!modalSelector) return;
    var modal = document.querySelector(modalSelector);
    if (!modal || typeof modal.show !== 'function') return;
    if (modal.hasAttribute('open')) return;
    e.stopPropagation();
    modal.show(toggle);
  },
  true
);

/**
 * Fix (found via the highlight briefly appearing then reverting): after
 * any image change, Shopify's native gallery code recalculates which
 * thumbnail should be highlighted based on horizontal scroll-position
 * math, about half a second later (there's a built-in debounce). That
 * calculation doesn't apply once the silicone mobile grid turns the
 * thumbnail strip into a multi-row grid, so it was overwriting our
 * correct highlight shortly after we set it, right when this delayed
 * recalculation ran.
 *
 * Rather than racing that timer, this stops that native recalculation
 * from running at all for the grid layout — we already manage the
 * highlight correctly ourselves at the moment of the tap.
 */
(function () {
  function patchSetActiveThumbnail() {
    var MediaGalleryClass = customElements.get('media-gallery');
    if (!MediaGalleryClass || MediaGalleryClass.prototype.__siliconePatched) return;
    var original = MediaGalleryClass.prototype.setActiveThumbnail;
    MediaGalleryClass.prototype.setActiveThumbnail = function (thumbnail) {
      if (
        this.elements &&
        this.elements.thumbnails &&
        this.elements.thumbnails.classList &&
        this.elements.thumbnails.classList.contains('silicone-mobile-thumb-grid')
      ) {
        return;
      }
      return original.call(this, thumbnail);
    };
    MediaGalleryClass.prototype.__siliconePatched = true;
  }
  patchSetActiveThumbnail();
})();

/**
 * Root-cause fix: the grid's color-thumbnail taps update the price/SKU/
 * cart info by dispatching a change event, which triggers a network
 * request that (among other things) completely rebuilds the full-screen
 * zoom popup's internal content from scratch. That rebuild is what
 * leaves the popup broken afterward — confirmed by the fact that
 * swiping between photos, which never triggers this same rebuild,
 * always worked fine.
 *
 * The hero photo itself already switches correctly on a grid tap
 * through Shopify's native thumbnail-click handling, independent of
 * this rebuild — so skipping just the modal-rebuild step here doesn't
 * lose anything. Price, SKU, inventory, and cart behavior are handled
 * elsewhere and are unaffected by this patch.
 */
(function () {
  function patchUpdateMedia() {
    var VariantSelectsClass = customElements.get('variant-selects');
    if (!VariantSelectsClass || VariantSelectsClass.prototype.__siliconeMediaPatched) return;
    var original = VariantSelectsClass.prototype.updateMedia;
    VariantSelectsClass.prototype.updateMedia = function (html) {
      var productEl = this.closest('.product');
      var mediaWrapper = productEl && productEl.querySelector('.product__media-wrapper');
      var thumbSlider = mediaWrapper && mediaWrapper.querySelector('.thumbnail-slider');
      if (thumbSlider && thumbSlider.classList.contains('silicone-mobile-thumb-grid')) {
        return;
      }
      return original.call(this, html);
    };
    VariantSelectsClass.prototype.__siliconeMediaPatched = true;
  }
  patchUpdateMedia();
})();
(function () {
  function neutralizeClosedModals() {
    document.querySelectorAll('product-modal, .media-modal').forEach(function (modal) {
      if (modal.hasAttribute('open')) {
        modal.style.pointerEvents = '';
      } else {
        modal.style.pointerEvents = 'none';
      }
    });
  }
  neutralizeClosedModals();
  var modalGuardObserver = new MutationObserver(neutralizeClosedModals);
  modalGuardObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  });
})();
